import { Injectable, Inject } from '@angular/core';
import { User } from './common/model/User';
import { Permission } from './common/model/Permission';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor( @Inject(SESSION_STORAGE) private storage: WebStorageService, private router: Router) { }

  logout() {
    this.storage.set('isLoggedIn', false);
    this.storage.remove('token');
    this.storage.remove('user');
    this.storage.remove('permissions');
    this.storage.remove('catDetLanguageId');
    this.storage.remove('moduleUrl');
    this.router.navigate(['/login']);
  }

  login(token: String, user: User, permissions: [Permission], catDetLanguageId: number) {
    this.storage.set('isLoggedIn', true);
    this.storage.set('token', token);
    this.storage.set('user', user);
    this.storage.set('permissions', permissions);
    this.storage.set('catDetLanguageId', catDetLanguageId);
  }

}
